<template>
  <div class="hayaban-osoban">
    <h3>早番・遅番</h3>
    <div class="item">
      <b class="required">勤務日</b>
      <date-picker v-model="hayabanOsoban.target_dakoku_date"
        :error="getError(hayabanOsoban, 'target_dakoku_date')"></date-picker>
    </div>

    <div class="item">
      <koyouKeiyakuTimeSelect :errors="hayabanOsoban.errors" :targetDate="hayabanOsoban.target_dakoku_date"
        @change="changeKoyouKeiyakuTime" :hideWorkTime="true">
      </koyouKeiyakuTimeSelect>
    </div>

    <div class="item">
      <b class="required">開始時間</b>
      <time-picker v-model="hayabanOsoban.start_datetime" :startTime="{ minutes: 0 }"
        :error="getError(hayabanOsoban, 'start_datetime')"></time-picker>
    </div>
    <div class="item">
      <b class="required">終了時間</b>
      <time-picker v-model="hayabanOsoban.end_datetime" :startTime="{ minutes: 0 }"
        :error="getError(hayabanOsoban, 'end_datetime')"></time-picker>
    </div>
    <div class="item">
      <b class="required">この日に取得した（する予定の）休憩時間</b>
      <time-picker v-model="hayabanOsoban.kyuukei_times" :startTime="{ hours: 0, minutes: 0 }"
        :error="getError(hayabanOsoban, 'kyuukei_times')" :minTime="{ hours: 0, minutes: 0, seconds: 0 }"
        :maxTime="{ hours: 2, minutes: 0, seconds: 0 }"></time-picker>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue';
import { useInit } from '@/composable/shinsei/hayaban_osoban/init';
import { useCreate } from '@/composable/shinsei/hayaban_osoban/create';
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuTimeSelectEmitData } from '@/types/SyuugyouBasyo';
import KoyouKeiyakuTImeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"
import { Logger } from '@/utils/Logger';

export default defineComponent({
  props: {
    shinseiDate: {
      type: String,
      default: null
    },
  },
  emits: ['changeKinmubi'],
  setup(props, context) {
    // エラー取得
    const { getError } = useForm()
    const { hayabanOsoban, getWorkTime } = useInit()
    const { create } = useCreate()
    const shiftType = ref(null)
    const sabunTime = ref(null)
    const hasWorkTimes = ref(false)

    const onSave = () => {
      hayabanOsoban.shinsei_date = props.shinseiDate
      create(hayabanOsoban)
    }

    const changeKoyouKeiyakuTime = async (emitData: KoyouKeiyakuTimeSelectEmitData) => {
      if (!hayabanOsoban.target_dakoku_date) return

      if (emitData.selectedSyuugyouBasyo) {
        hayabanOsoban.koyou_keiyaku_id = emitData.selectedSyuugyouBasyo.koyou_id
        hayabanOsoban.mst_syuugyou_basyo_id = emitData.selectedSyuugyouBasyo.val

        if (emitData.selectedSyuugyouBasyo.work_times) {
          hasWorkTimes.value = getWorkTime(hayabanOsoban.target_dakoku_date, emitData.selectedSyuugyouBasyo.work_times)
        }
        Logger.debug('雇用契約IDと就業場所IDをセットしました', hayabanOsoban)
      } else {
        hayabanOsoban.koyou_keiyaku_id = null
        hayabanOsoban.mst_syuugyou_basyo_id = null
        hasWorkTimes.value = false
        Logger.debug('雇用契約IDと就業場所IDがクリアされました', hayabanOsoban)
      }
    }

    return {
      hayabanOsoban,
      shiftType,
      sabunTime,
      getError,
      onSave,
      changeKoyouKeiyakuTime,
      hasWorkTimes,
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTImeSelect
  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
